module.exports = __webpack_public_path__ + "img/main_old2.312e7faa.jpg";